export default __webpack_public_path__ + "static/media/gl_2.259670b6.png";